/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) System Sort Icon component.
 */
export const SystemSortIcon = ({size, ...props}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({size});
  return (
    <ThemeIconProvider name='SystemSortIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d='M10.95 8.68L5.87 4 1 8.68M5.97 19.22V5.58M12.48 14.54l5.08 4.68 4.87-4.68M17.45 4v13.64'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeLinecap='round'
          strokeLinejoin='round' />
      </svg>
    )} />
  );
};
